module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/noGamesIcons/noGames/nba/weekly-29e053a460efbef196c6bef69af19f44.svg";